<template>
    <div>
        <Layout>
            <Content class="content">
                <div class="box">
                    <span class="item">
                        <NextBar v-if="renderbar" :style="{display:showBar?'block':'none'}" :isHidden=true :isShowPaperWord=true ref="casesearch" @next-search="nextSearch"></NextBar>
                    </span>
                    <span class="item">
                        <RTable class="jd-table-overflow" ref="caseTable" @onPageChange="pageChange" />
                    </span>
                </div>
            </Content>
            <Spin fix v-if="spinShow3">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div v-if="loadSucess">数据加载中...</div>
                <div v-else>加载失败</div>
            </Spin>
        </Layout>
    </div>
</template>
<script>
import caseHeader from '../../assets/json/caseTableData.json'
import nextSearchBar from '../common/common_engine/nextSearchBar3.vue'
import rtable from '../common/common_engine/resulttable.vue'
import eventBus from "../common/event_bus.js"
import More from "../../api/common/more.js"
import store from '../../store/'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
let MoreFun = new More()
export default {
    inject: ["getSliders"],
    data() {
        return {
            rid: +new Date(),
            showBar: true,
            psize: 10,
            index: 1,
            searchtxt: '',
            spinShow3: true,
            loadSucess: true,
            sliders: this.getSliders(),
            nextValue: null,
            courtloadflag:false,
            paperwordloadflag:false,
            renderbar:false,
        }
    },
    components: {
        'NextBar': nextSearchBar,
        'RTable': rtable,
    },
    created() {
        //store.state.user.initData.currentVersion = '2'
        //this.$refs.myAsideMenu.init()
        console.log('paperword create==>')
        this.$nextTick(() => {
            if (store.state.user.initData.court.length === 0 || store.state.user.initData.paperword.length === 0) {
                console.log('拉取court数据以及paperword分类数据')
                this.getCourt()
            } else {
                console.log('已存在缓存数据')
                //console.log(store.state.user.initData.court)
                this.spinShow3 = false
                this.renderbar=true
                // var courtlist = Array.from(store.state.user.initData.court,(x)=>x.name)
                // this.$refs.casesearch.list=courtlist

            }

        })

        //this.test()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        pageChange(index, name) {
            this.index = index
            if (this.nextValue) {
                this.test(this.nextValue)
            } else {
                this.test()
            }
            //console.log(index,name)
        },
        nextSearch(value) {
            console.log(value)
            this.nextValue = value
            this.index = 1
            this.test(value)
        },
        test(nxtValue) {
            var item = {}
            item.text =
                item.stime = nxtValue ? nxtValue.time[0] : ''
            item.etime = nxtValue ? nxtValue.time[1] : ''
            item.potence = ""
            item.tagid = ""
            item.text2 = nxtValue ? nxtValue.text : ''
            item.ps = { "p": '', "c": '' }
            item.tagpc = []
            item.fs = true
            item.ft = false
            item.id = nxtValue ? nxtValue.paperword : ''
            item.court = nxtValue ? nxtValue.court : ''
            item.courttype = nxtValue ? nxtValue.courttype : 0
            item.scencs = 'paperword' ////场景(policy:政策,answer:解答,paperword:文书)
            console.log(item)

            constJ.reqGetGeneralFiles(this.psize, this.index, item, true).then(res => {
                console.log(res)
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        var obj = null
                        if (res.tbls.length > 0) {
                            obj = {
                                header: caseHeader.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: res.tbls[0].divisiontag,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                isws: true,
                                isjd: false,
                                iscase: false,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: this.index,
                                showColumns: MoreFun.getColumns().case,
                            }
                        } else {
                            //默认
                            obj = {
                                header: testData2.header,
                                tabrows: null,
                                total: 0,
                                tabname: "general",
                                tags: res.tbls[0].classifytag,
                                level: null,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                                index: currentIndex,
                                showColumns: [],
                            }
                        }
                        this.$refs.caseTable.show(obj)
                    } else {
                        this.$Message.error(res.rtncode)
                        console.log(res.rtncode)
                        return
                    }
                } else {
                    this.$Message.error(res.rltcode)
                    console.log(res.rltcode)
                    return
                }
            })
        },

        getCourt() {
            constJ.reqGetCourtList().then(res => {
                console.log(res)
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        store.commit("setCourt", res.datas)
                        this.getPaperWord()
                    }
                }
            })
        },
        getPaperWord() {
            constJ.reqGetPaperWordList().then(res => {
                console.log(res)
                let list = []
                if (res.rltcode === 1) {
                    if (res.rtncode === 1) {
                        list.push({ value: '000998', label: '全部分类' })
                        res.datas.forEach(item => {
                            let li = {
                                value: item.code,
                                label: item.text
                            }
                            list.push(li)
                        })
                        store.commit("setPaperWord", list)
                        // console.log(list)
                        this.spinShow3 = false
                        this.renderbar=true
                    }
                }
            })
        },
    },
    //监控多屏状态下隐藏其他字段显示，单屏还原
    watch: {
        sliders: function(v) {
            console.log('case sliders--->')
            console.log(v)
            this.$refs.caseTable.onSlidersChanged(MoreFun.getColumns().case)
        }
    }

}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .item {
        margin-top: 10px;
    }

}

.content {
    padding: 0 0 0 10px;
    // Height: 749px;
    background: #fff;
    Height: 78.8vh;
}

.jd-table-overflow {
    height: 69vh;
    overflow-y: auto;
}
</style>